import app from '@/main'

async function userUnblock (id) {
  return await app.wsp.sendRequest({
    data: {
      id: id
    },
    method: 'user.unblock'
  })
}

export default userUnblock